import { ENDPOINTS } from 'src/constants/endpoints'

import { http } from 'src/interfaces/http'

import type { IKnapCurrentUserDTO } from './types'

export const getCurrentUser = async (): Promise<IKnapCurrentUserDTO> => {
  const { data } = await http.get<IKnapCurrentUserDTO>(
    ENDPOINTS.auth.currentUser,
  )
  return data
}
